import { render, staticRenderFns } from "./DatosLegajo.vue?vue&type=template&id=2d72ddb9"
import script from "./DatosLegajo.vue?vue&type=script&lang=js"
export * from "./DatosLegajo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports